import { gql } from '@apollo/client';

export const categoryFragment = gql`
fragment CategoriesFragment on Category {
        name,
        id
}`;

export const deviceFragment = gql`
fragment DevicesFragment on Device {
        id
        name
        customName
}`;

export const taxFragment = gql`
fragment TaxesFragment on Tax {
    name,
    id
}
`;

export const venueFragment = gql`
fragment VenuesFragment on Venue {
    name,
    id
}
`;

export const sectionFragment = gql`
fragment SectionsFragment on Section {
    name,
    id
}
`;

export const warehousesFragment = gql`
fragment WarehousesFragment on Warehouse {
    name,
    id
}
`;

export const suppliersFragment = gql`
fragment SuppliersFragment on Supplier {
    id
    legalName
}
`;

